import api from "@/api";

export default {
    namespaced: true,
    state:{
        stateAlert: false,
    },
    getters: {
        getAlert: state => state.stateAlert,
    },
    mutations: {
        SET_ALERT(state, payload) {
            state.stateAlert = payload;
        },
    },
    actions: {
        async changeState({ commit }) {

            const response = await api.verifyServicesStatus();
            const status = response['data']['status'];
            commit('SET_ALERT', status);
        },
    },
};